import { cn } from '../../utils/cn'

export default function Card({ className, children, ...props }) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-slate-200/70 bg-white shadow-sm',
        'transition-shadow duration-200',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export function CardHeader({ className, title, subtitle, action, ...props }) {
  return (
    <div className={cn('px-5 pt-5', className)} {...props}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          {title ? <h2 className="text-lg sm:text-xl font-bold text-slate-900">{title}</h2> : null}
          {subtitle ? <p className="text-sm text-slate-600 mt-1">{subtitle}</p> : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
    </div>
  )
}

export function CardBody({ className, children, ...props }) {
  return (
    <div className={cn('px-5 pb-5 pt-4', className)} {...props}>
      {children}
    </div>
  )
}

